import { Input } from '@aqarmap/aqarmap-ui';
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '~/hooks';
import { addListingDetailsType } from '~addListing/types';

const OverPrice = ({ defaultOverPrice }: { defaultOverPrice: number }) => {
  const { t } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();

  const { setValue } = useFormContext<addListingDetailsType>();

  const paymentPlans = useWatch({ name: 'paymentPlans' });
  const paymentMethod = useWatch({ name: 'paymentMethod' });

  const overPriceValue = paymentPlans?.[0]?.overPrice || 0;

  const handleChange = (value: string) => {
    setValue(
      'paymentPlans.0.overPrice',
      Number(value.split(',').join('')) ?? '',
    );
  };

  useEffect(() => {
    setValue('paymentPlans.0.overPrice', defaultOverPrice);
  }, [defaultOverPrice, paymentMethod]);

  return (
    <Input
      label={{
        component: (
          <p className="text-title-4 flex gap-x items-center">
            <span>{t('overPrice')}</span>
            <span className="text-gray__dark_1 text-body-2">
              ({t('optional')})
            </span>
          </p>
        ),
      }}
      field={{
        type: 'text',
        placeholder: t('overPrice'),
        onChange: (e) => handleChange(e.target.value),
        value: overPriceValue ? overPriceValue?.toLocaleString() : '',
      }}
      className="flex-1"
      endIcon={
        <p className="border-s ps-x border-gray text-body_2 text-gray__dark_1">
          {mobileScreen ? t('pound') : t('egyptianPound')}
        </p>
      }
    />
  );
};

export default OverPrice;
